import { downloadProjectList as downloadProjectListReq } from '@gp/services/project';
import { getDownLoadCSVResponseHeaderFileName } from '@gp/utils/common';

export async function downloadProjectList(params: any): Promise<any> {
  try {
    const { headers, data, status } = await downloadProjectListReq(params);
    if (status !== 200) {
      return Promise.reject(new Error('downloadProjectList error'));
    }
    const fileName = getDownLoadCSVResponseHeaderFileName(headers);
    return Promise.resolve({ stream: data, fileName });
  } catch (exception) {
    console.warn(exception);
    return Promise.reject(exception);
  }
}
